import { useCallback } from "react";

import useLocalForage from "features/common/hooks/useLocalForage";

const HAS_VISITED_EXAM_PREP_KEY = "has-visited-exam-prep";
const VISIT_LIMIT = 3;

export default function useHasVisitedExamPrep() {
  const { value: examPrepVisits, set } = useLocalForage({
    key: HAS_VISITED_EXAM_PREP_KEY,
    initialValue: 0
  });

  const incrementExamPrepVisits = useCallback(
    () => set(examPrepVisits! + 1),
    [examPrepVisits, set]
  );

  const examPrepVisitsLimitReached =
    examPrepVisits && examPrepVisits >= VISIT_LIMIT;

  return { examPrepVisitsLimitReached, incrementExamPrepVisits };
}
